import React from 'react';
import classnames from 'classnames';
import { scaleToSize } from '../../_helpers';
import s from './Image.scss';
export var ImageContent = function (_a) {
    var width = _a.width, height = _a.height, file = _a.file, isPixel = _a.isPixel, canZoom = _a.canZoom, onZoom = _a.onZoom;
    var size = scaleToSize(file, { width: width, height: height });
    return (React.createElement("img", { alt: "", className: classnames(s['image'], isPixel && s['pixel'], canZoom && s['zoomable']), src: file.src, style: size, onClick: canZoom ? onZoom : undefined }));
};
ImageContent.displayName = 'ImageContent';
export default ImageContent;
//# sourceMappingURL=ImageContent.js.map